import { render, staticRenderFns } from "./TableSelectiveprocess.vue?vue&type=template&id=6c58712c&"
import script from "./TableSelectiveprocess.vue?vue&type=script&lang=js&"
export * from "./TableSelectiveprocess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports